import { Injectable } from '@angular/core';
import { AjustesProvider } from '../ajustes/ajustes';
import * as CryptoJS from 'crypto-js';
import { catAccionesPorModulo } from 'src/app/models/catalogos/catAccionesPorModulo-data.model';

@Injectable({
    providedIn: 'root'
})

export class CryptoProvider {
    constructor(
        private ajustesProvider: AjustesProvider,
    ) { }
    public decryptData(encryptedText: string) {
        const encryptedBytes = CryptoJS.enc.Base64.parse(encryptedText);

        // Define the key and IV
        const keyBytes = CryptoJS.enc.Utf8.parse(this.ajustesProvider.ajustes.realm); // Ensure this matches the key used in C#
        const iv = CryptoJS.enc.Hex.parse('00000000000000000000000000000000'); // 16 bytes of zeros

        // Decrypt the data
        const decrypted = CryptoJS.AES.decrypt(
            { ciphertext: encryptedBytes },
            keyBytes,
            {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            }
        );

        // Convert the decrypted data to a UTF-8 string
        return decrypted.toString(CryptoJS.enc.Utf8);
    }
    public encryptData(plainText: string) {
        return plainText;
        // Define the key and IV
        const keyBytes = CryptoJS.enc.Utf8.parse(this.ajustesProvider.ajustes.realm); // Asegúrate de que esto coincida con la clave utilizada en C#
        const iv = CryptoJS.enc.Hex.parse('00000000000000000000000000000000'); // 16 bytes de ceros

        // Cifrar los datos
        const encrypted = CryptoJS.AES.encrypt(
            plainText,
            keyBytes,
            {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            }
        );

        // Convertir el texto cifrado a Base64
        return encodeURIComponent(encrypted.ciphertext.toString(CryptoJS.enc.Base64));
    }
    public encryptValidar(plainText: string) {
        //return plainText;
        // Define the key and IV
        const keyBytes = CryptoJS.enc.Utf8.parse(this.ajustesProvider.ajustes.realm); // Asegúrate de que esto coincida con la clave utilizada en C#
        const iv = CryptoJS.enc.Hex.parse('00000000000000000000000000000000'); // 16 bytes de ceros

        // Cifrar los datos
        const encrypted = CryptoJS.AES.encrypt(
            plainText,
            keyBytes,
            {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            }
        );

        // Convertir el texto cifrado a Base64
        return encodeURIComponent(encrypted.ciphertext.toString(CryptoJS.enc.Base64));
    }
    public decryptAccionesPorModulo(encryptedAccionesPorModulo: any[]): catAccionesPorModulo[] {
        if (!Array.isArray(encryptedAccionesPorModulo)) {
            throw new Error("Input must be an array");
        }

        return encryptedAccionesPorModulo.map(module => ({
            IdAccionModulo: module.IdAccionModulo ? parseInt(this.decryptData(module.IdAccionModulo)) : null,
            IdModulo: module.IdModulo ? parseInt(this.decryptData(module.IdModulo)) : null,

            strNombre: module.strNombre ? this.decryptData(module.strNombre) : null,
            strDescripcion: module.strDescripcion ? this.decryptData(module.strDescripcion) : null,

            blnActivo: module.blnActivo !== undefined ? this.decryptData(module.blnActivo) : null,
            IdUsuarioAlta: module.IdUsuarioAlta ? parseInt(this.decryptData(module.IdUsuarioAlta)) : null,
            dteFechaAlta: module.dteFechaAlta ? this.decryptData(module.dteFechaAlta) : null,
            dteFechaActualizacion: module.dteFechaActualizacion ? this.decryptData(module.dteFechaActualizacion) : null,
            IdUsuarioActualizacion: module.IdUsuarioActualizacion ? parseInt(this.decryptData(module.IdUsuarioActualizacion)) : null
        }));
    }
}
